import {type DimensionAsObject} from './types';

/** The displayed size at a numeric zoom, floored per axis with a one-pixel minimum. */
export function zoomedSize(
  natural: DimensionAsObject,
  zoomPercentage: number
): DimensionAsObject {
  return {
    width: Math.max(1, Math.floor((natural.width * zoomPercentage) / 100)),
    height: Math.max(1, Math.floor((natural.height * zoomPercentage) / 100)),
  };
}
